import {graphql} from '~/graphql-react-query/';

export const TeamIncrementDownloadCount = graphql(`
    mutation TeamIncrementDownloadCountMutation($teamId: UUID!) {
        team {
            teamIncrementDownloadCount(mutation: {id: $teamId}) {
                id
                metadata
                updatedAt
            }
        }
    }
`);

export const TeamItemQuery = graphql(`
    query TeamItemQuery($teamId: UUID!) {
        team {
            team(teamId: $teamId) {
                id
                name
                members {
                    teamId
                    userId
                    user {
                        id
                        username
                        name
                    }
                    role
                    createdAt
                    updatedAt
                }
                products {
                    product
                    industryIds
                    mediaTypeIds
                    status
                    metadata
                    country
                }
                invites(status: [PENDING]) {
                    id
                    username
                    role
                    status
                    createdAt
                    team {
                        id
                    }
                    inviter {
                        id
                    }
                }
                createdAt
                updatedAt
            }
        }
    }
`);

export const TeamCreateWithInvite = graphql(`
    mutation teamCreateWithInvite($teamName: String!, $email: String!, $inviterId: String!) {
        team {
            teamCreateWithInvite(
                mutation: {teamName: $teamName, email: $email, inviterId: $inviterId}
            ) {
                id
                name
                status
                invites(status: [PENDING]) {
                    id
                    username
                    role
                    status
                    createdAt
                }
                createdAt
                updatedAt
            }
        }
    }
`);

export const TeamInviteResendMutation = graphql(`
    mutation teamInviteResendMutation($inviteId: UUID!) {
        team {
            teamResendInvite(mutation: {inviteId: $inviteId})
        }
    }
`);

export const TeamRemoveInviteMutation = graphql(`
    mutation teamRemoveInviteMutation($inviteId: UUID!) {
        team {
            teamRemoveInvite(mutation: {inviteId: $inviteId})
        }
    }
`);

export const TeamMemberRemoveMutation = graphql(`
    mutation TeamMemberRemoveMutation($userId: String!, $teamId: UUID!) {
        team {
            teamRemoveUser(mutation: {userId: $userId, teamId: $teamId})
        }
    }
`);

export const TeamMemberUpdateMutation = graphql(`
    mutation TeamMemberUpdateMutation($id: UUID!, $userId: String!, $role: TeamMemberRole!) {
        team {
            teamUpdateUser(mutation: {teamId: $id, userId: $userId, role: $role}) {
                teamId
                userId
                role
                updatedAt
            }
        }
    }
`);

export const TeamResetDownloadCountMutation = graphql(`
    mutation TeamResetDownloadCountMutation($teamId: UUID!) {
        team {
            teamResetDownloadCount(mutation: {id: $teamId}) {
                id
                metadata
                updatedAt
            }
        }
    }
`);

export const TeamMemberAddMutation = graphql(`
    mutation TeamMemberAddMutation($member: AddUserToTeamInput!) {
        team {
            teamAddUser(mutation: $member) {
                userId
                teamId
                role
                status
                createdAt
                team {
                    id
                    members {
                        userId
                        user {
                            id
                            username
                            name
                        }
                        role
                        status
                        createdAt
                        updatedAt
                    }
                }
            }
        }
    }
`);

export const TeamMemberInviteMutation = graphql(`
    mutation TeamMemberInviteMutation($invite: InviteUserToTeamInput!) {
        team {
            teamInviteUser(mutation: $invite) {
                id
                username
                role
                status
                createdAt
                team {
                    id
                    members {
                        userId
                        user {
                            id
                            username
                            name
                        }
                        role
                        status
                        createdAt
                        updatedAt
                    }
                    invites(status: [PENDING]) {
                        id
                        username
                        role
                        status
                        createdAt
                        inviter {
                            id
                        }
                    }
                }
                inviter {
                    id
                }
            }
        }
    }
`);

export const RemoveTeamMutation = graphql(`
    mutation removeTeam($teamId: UUID!) {
        team {
            teamRemove(mutation: {teamId: $teamId})
        }
    }
`);

export const TeamUpdateMutation = graphql(`
    mutation TeamUpdate($id: UUID!, $name: String!) {
        team {
            teamUpdate(mutation: {id: $id, name: $name}) {
                id
                name
            }
        }
    }
`);

export const TeamUpdateProductsMutation = graphql(`
    mutation TeamUpdateProducts($id: UUID!, $products: [TeamProductInput!]!) {
        team {
            teamUpdateProducts(mutation: {teamId: $id, teamProducts: $products}) {
                product
                industryIds
                mediaTypeIds
                status
                metadata
                country
            }
        }
    }
`);

export const TeamListQuery = graphql(`
    query TeamListQuery(
        $search: String
        $status: TeamProductStatusFilter
        $country: String
        $industryList: [String!]
    ) {
        team {
            teamList(
                search: $search
                status: $status
                country: $country
                industryList: $industryList
            ) {
                id
                name
                status
                createdAt
                updatedAt
                members {
                    teamId
                    userId
                }
                products {
                    product
                    status
                    industryIds
                    metadata
                    country
                }
            }
        }
    }
`);

export const TeamAddNzTrialMutation = graphql(`
    mutation TeamAddNzTrial($input: AddNzTrialInput!) {
        team {
            teamAddNzTrial(mutation: $input) {
                id
                name
                status
                createdAt
                updatedAt
                metadata
                members {
                    teamId
                    userId
                    user {
                        username
                        id
                    }
                }
                products {
                    product
                    status
                    industryIds
                    metadata
                    country
                }
            }
        }
    }
`);
